<template>
<v-btn id="btRelatorios" text rounded>
    <v-icon left>mdi-printer</v-icon>
      {{ label }}
    <v-icon right>mdi-menu-down</v-icon>

    <v-menu bottom offset-y transition="slide-y-transition" activator="#btRelatorios">
      <!-- <template v-slot:activator="{ on, attrs }">
      </template> -->

      <v-list nav dense>
        <v-subheader class="text-uppercase text--primary font-weight-black">{{ sublabel }}</v-subheader>
        <template v-for="(impressao, index) in itens">
          <v-list-item :key="index" @click="emitir(impressao)" v-show="impressao.visible">
            <v-list-item-icon>
              <v-icon>mdi-card-text-outline</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ impressao.texto }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-menu>

  </v-btn>
</template>

<script>

  export default {
    name: 'zMenuImpressoes',

    props: {
      label: {
        type: String,
        default: 'Imprimir'
      },

      sublabel: {
        type: String,
        default: 'Impressões'
      },

      itens: {
        type: Array,
        default: () => []
      },
    },

    methods: {
      emitir(relatorio) {
        if (typeof relatorio.acao === 'function') {
          // this.$emit('abrir:relatorio')
          relatorio.acao();
        } else if (typeof relatorio.acao === 'string') {
          this.$emit('abrir:relatorio', relatorio.acao);
        } else {
          console.log('A variável não é nem uma função nem uma string.');
        }
      }
    },


  }
</script>

<style scoped>

</style>